import { useEffect, useState } from "react";
import { api } from "@/lib/api";

/**
 * Loads the firing timeline for a given alert rule.
 * items === null   → still loading
 * items === []     → loaded, empty
 * items === [...]  → loaded with data
 */
export function useRuleFirings(rule, limit = 200) {
  const [items, setItems] = useState(null);

  useEffect(() => {
    if (!rule) { setItems(null); return; }
    let cancelled = false;
    setItems(null);
    api.get(`/alert-rules/${rule.id}/firings?limit=${limit}`)
      .then((r) => { if (!cancelled) setItems(r.data); })
      .catch(() => { if (!cancelled) setItems([]); });
    return () => { cancelled = true; };
  }, [rule, limit]);

  return items;
}
